const FeedbackTypes = {
    unknown: 'unknown',
    candidate: 'candidate',
    other: 'other',
}

export { FeedbackTypes };